import MUIDataTable from 'mui-datatables'
import React from 'react'
import { Link } from 'react-router-dom';
import Toggle from 'react-toggle';
import moment from 'moment';
import { FaEdit, FaEye } from 'react-icons/fa'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getServiceProviderList } from '../../../actions/homeAction';

const ServiceProvider = () => {

    const userList = []

    const columns = [
        {
            // Hidden, fixed at rowData[0] so the Actions link can read it reliably.
            name: 'businessId',
            label: 'businessId',
            options: { display: false, filter: false, sort: false },
        },
        {
            name: 'username',
            label: 'User Name',
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: 'firstName',
            label: 'First Name',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },

        {
            name: 'lastName',
            label: 'Last Name',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: 'mobileNumber',
            label: 'Phone No',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'userType',
            label: 'User Type',
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
         {
            name: 'businessName',
            label: 'Service Type',
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: 'mobileVerified',
            label: 'Mobile Verified',
            options: {
                filter: false,
                sort: true,customBodyRender: mobileVerified => {
                    return <div className={mobileVerified ? 'text-success' : 'text-danger'}>{mobileVerified ? 'Verified' : 'Not-Verified' }</div>
                },
            },
        },
        {
            name: 'createdAt',
            label: 'Date of Registration',
            options: {
                filter: true,
                sort: true,
                customBodyRender: createdAt => {
                    return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
                },
            },
        },
        {
            name: 'latestSubscriptionExpiry',
            label: 'Membership Expiry',
            options: {
                filter: false,
                sort: true,
                customBodyRender: latestSubscriptionExpiry => {
                    return latestSubscriptionExpiry ? moment(latestSubscriptionExpiry).format('DD/MM/YYYY , hh:mm A') : 'N/A';
                },
            },
        },
        {
            name: 'latestSubscriptionPlan',
            label: 'Membership Plan',
            options: {
                filter: false,
                sort: true,
                customBodyRender: latestSubscriptionPlan => {
                    return latestSubscriptionPlan || 'N/A';
                },
            },
        },
        // {
        //     name: 'activeAdsCount',
        //     label: 'Active Ads',
        //     options: {
        //       filter: false,
        //       sort: true,
        //     },
        //   },
        //   {
        //     name: 'expiredAdsCount',
        //     label: 'Expired Ads',
        //     options: {
        //       filter: false,
        //       sort: true,
        //     },
        //   },
        //   {
        //     name: 'totalPaidAmount',
        //     label: 'Amount Paid',
        //     options: {
        //       filter: false,
        //       sort: true,
        //     },
        //   },
        // {
        //     name: '5',
        //     label: 'Action',
        //     options: {
        //         filter: true,
        //         sort: true,
        //         display: false,
        //         customBodyRender: (id, tableMeta) => {
        //             return (
        //                 <div>
        //                     <Link
        //                         to={'/user/add/:user_id?'}
        //                         className='m-r-15 text-muted'
        //                         data-toggle='tooltip'
        //                         data-placement='top'
        //                         title=''
        //                         data-original-title='Edit'>
        //                         <i className='f-20 icofont icofont-ui-edit text-custom'></i>
        //                     </Link>
        //                     <Link
        //                         to={'/user/View/'}
        //                         // onClick={this.deleteUser.bind(this, id)}
        //                         className='m-r-15 text-muted'
        //                         data-toggle='tooltip'
        //                         data-placement='top'
        //                         title=''
        //                         data-original-title='View'>
        //                         <i className='f-26 icofont icofont-eye text-black'></i>{' '}
        //                     </Link>
        //                 </div>
        //             );
        //         },
        //     },
        // },

        {
            name: 'status',
            label: 'Status',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    // var Id = tableMeta.rowData[7];
                    // console.log(tableMeta.rowData[6]);
                    return (
                        <div className={status === 'active' ? 'st-active': 'st-inactive'}>{status === 'active' ? 'Active': 'In-Active'}</div>
                        // <Toggle
                        //     id={'status_' + Id}
                        //     checked={status}
                        //     value={status}
                        //     onChange={this.handleStatusChange.bind(this, Id, status)}
                        // />
                    );
                },
            },
        },
        {
            name: 'userId',
            label: 'Actions',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (userId, tableMeta) => {
                    const businessId = tableMeta?.rowData?.[0];
                    return(
                        <div>
                            <Link to={`/service-provider/view/${userId}/${businessId}`} title="View">
                                <FaEye style={{fontSize: '1.4rem'}} />
                            </Link>
                        </div>
                    )
                }
            }
        }
    ];

    const options = {
        filter: false,

        viewColumns: false,
        print: false,
        download: false,
        search: true,
        selectableRows: 'none',
    };

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getServiceProviderList())
    },[])

    const spList = useSelector(state => state.home.serviceProvideList)?.response
    // console.log("spList", spList);
    
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
									</div>
									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											
											{spList !== undefined ? (
												<MUIDataTable
													title={'Service Providers List'}
													className='table-responsive'
													data={spList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default ServiceProvider